const { VUE_APP_URL } = process.env;

export default VUE_APP_URL;
